package net.frozenbit.games.soundgame.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.components.AvatarSelector

@Composable
fun ControllerLobbyScreen(
    showStartButton: Boolean,
    enableStartButton: Boolean,
    selectedAvatarIndex: Int?,
    onStartButtonClicked: () -> Unit,
    onAvatarSelected: (Int) -> Unit,
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(16.dp, Alignment.Top),
        modifier = Modifier
            .fillMaxSize()
            .padding(top = 8.dp)
    ) {
        AvatarSelector(
            selectedAvatarIndex = selectedAvatarIndex,
            onAvatarSelected = onAvatarSelected,
        )
        if (showStartButton) {
            Button(
                onClick = onStartButtonClicked,
                enabled = enableStartButton,
            ) {
                Text("Alle Spieler bereit - START")
            }
        } else {
            Text("Warte bis Spieler 1 das Spiel startet ...")
        }
    }
}